import React from 'react';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
const MerchantLogo = ({ data }) => {
    if (!data) {
        return null;
    }
    return <TransactionLogo R44 transaction={{ merchant: data }}/>;
};
export default MerchantLogo;
